import { ServiceMetricsDataCellProps } from '../types';
import { renderIntegrationHealthByRequestAndSuccessCountPercent } from 'utils';

const ServiceMetricsHealthCell = ({
  integrationHealth,
  targetServiceId,
  mosaicTeamId,
  _customRowProps,
}: ServiceMetricsDataCellProps) => {
  const { navigateToIntegrationHealth, currentService } = _customRowProps;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigateToIntegrationHealth({
      targetService: currentService,
      targetServiceId,
      teamId: mosaicTeamId,
    });
  };

  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      {renderIntegrationHealthByRequestAndSuccessCountPercent({
        integrationHealth,
        className: 'icon-only',
      })}
    </div>
  );
};

export default ServiceMetricsHealthCell;
